export default __webpack_public_path__ + "static/financial-proffesion-v3-e7f4a2de9f48d60329a7c781dd64fea0.svg";